import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isProcessing: false
};

export const loader = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    startProcessing: (state) => {
      state.isProcessing = true;
    },
    stopProcessing: (state) => {
      state.isProcessing = false;
    },
    loaderReset: () => {
      return initialState;
    }
  }
});

// Action creators are generated for each case reducer function
export const { startProcessing, stopProcessing, loaderReset } = loader.actions;

export default loader.reducer;
